import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormatSizeUnitsPipe } from './format-size-units.pipe';

@NgModule({
  imports: [CommonModule],
  declarations: [FormatSizeUnitsPipe],
  exports: [FormatSizeUnitsPipe],
})
export class FormatSizeUnitsModule {}
